<template>
  <div id="NCAHome">
    <Home ref="homeCmp" />
  </div>
</template>

<script>
import Home from './components/home.vue';
export default {
  name: 'App',
  components: {
    Home,
  },
  mounted() {
    this.initTab(this.$route.path);
  },
  watch: {
    $route(to, from) {
      this.initTab(to.path);
      const toPath = to.path.split('/');
      const fromPath = from.path.split('/');
      if (fromPath.length === 3 && toPath.length === 2) { // 有id到无id
        // id
        this.$nextTick(() => {
          const refs = this.$refs.homeCmp.$refs.routerCmp;
          if (toPath[1] === 'activePrograms' || toPath[1] === 'closedPrograms') {
            refs.isDetail = false;
          } else if (toPath[1] === 'pendingApps') {
            refs.isSelected = false;
          } else if (toPath[1] === 'resources') {
            refs.isShowAll = false;
          }
        });
      } else if (fromPath.length === 2 && toPath.length === 3) { // 无id到有id
        this.$nextTick(() => {
          const refs = this.$refs.homeCmp.$refs.routerCmp;
          refs.setRecordById() // 此时需要重新获取数据，以便浏览器点击back能显示数据
          if (toPath[1] === 'activePrograms' || toPath[1] === 'closedPrograms') {
            refs.isDetail = true;
          } else if (toPath[1] === 'pendingApps') {
            refs.isSelected = true;
          } else if (toPath[1] === 'resources') {
            refs.isShowAll = true;
          }
        });
      }
    },
  },
  methods: {
    initTab(path) {
      window.siderBarTabs.forEach((tab) => {
        if (path.indexOf(tab.routerPath) > -1) {
          this.$store.commit('CURRENT_TAB_CHANGED', tab);
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import './sass/main.scss';

@font-face {
  font-family: ncaDashboardFont;
  src: url(./sass/SF-Pro-Text-Semibold.ttf);
}

#NCAHome {
  font-family: ncaDashboardFont, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-weight: 500;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue